<template>
  <div>
    <section class="song-search hero is-primary">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-vcentered">
            <div class="column">
              <div class="field">
                <p
                  class="control has-icons-left has-icons-right"
                  :class="{ 'is-loading': false }"
                >
                  <input
                    v-model="filter"
                    class="input"
                    type="text"
                    placeholder="Search"
                    @keydown.esc.prevent="clearFilter()"
                  >
                  <span class="icon is-small is-left">
                    <i class="fas fa-search" />
                  </span>
                  <span class="icon is-small is-right clickable">
                    <a
                      v-if="filter"
                      class="delete"
                      href="#"
                      @click.prevent="clearFilter()"
                    />
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="song-list">
      <div
        v-for="song in songs"
        :key="song.id"
        class="song is-fullwidth"
        @click="showSong(song)"
      >
        <div class="container">
          <div class="content">
            <p class="list-element-title">
              <span v-text="song.title" />
            </p>
          </div>
        </div>
      </div>
    </div>
    <BaseRouterRoundButton :destination="addLink" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { debounce } from "lodash";
import { onBottom } from "src/services/infinite-loading";

export default {
  data() {
    return {
      addLink: "new-song"
    };
  },
  computed: {
    ...mapGetters({
      songs: "songs"
    }),
    filter: {
      get() {
        return this.$store.getters.songsFilter;
      },
      set(value) {
        this.changeFilter(value).then(this.debouncedRefreshSongs.bind(this));
      }
    }
  },
  mounted() {
    onBottom(() => {
      this.loadMoreSongs();
    });
  },
  beforeDestroy() {
    window.onscroll = () => {};
  },
  methods: {
    setupQuery(filter) {
      const query = {};
      if (filter) {
        query.filter = filter;
      }
      this.$router.replace({ query });
    },
    showSong(song) {
      this.$router.push({ name: "song", params: { id: song.id } });
    },
    changeFilter(value) {
      this.setupQuery(value);
      return this.changeSongsFilter({ main: value, tags: [] });
    },
    clearFilter() {
      return this.changeFilter("").then(this.quickRefreshSongs.bind(this));
    },
    quickRefreshSongs() {
      return this.refreshSongs().then(this.loadMoreSongs());
    },
    debouncedRefreshSongs: debounce(function() {
      return this.quickRefreshSongs();
    }, 500),
    ...mapActions(["changeSongsFilter", "refreshSongs", "loadMoreSongs"])
  }
};
</script>

<style lang="scss">
.song-search .hero-body {
  padding: 1.5rem;
}
.song {
  @include list-element($fa-var-music);
}
.add {
  @include action-button();
}
.control .icon.clickable {
  .delete {
    pointer-events: auto;
  }
}
</style>



// WEBPACK FOOTER //
// Songs.vue?5cdbe8e6